import { Button, CloseButton, Dialog, Portal, Text } from '@chakra-ui/react';
import { FC, useRef } from 'react';
import { ErrorState } from '../../context/error-state-context';
import useLanguageSelector from '../../hooks/useLanguageSelector';
type Props = {
  dismissError: () => void;
  errorState: ErrorState | null;
};
const ErrorDialog: FC<Props> = ({ dismissError, errorState }) => {
  const LANG = useLanguageSelector();
  const contentRef = useRef<HTMLDivElement>(null);
  const dialogContentProps: Dialog.ContentProps = {
    ref: contentRef
  };
  const dialogCloseProps: Dialog.CloseTriggerProps = {
    asChild: true
  };
  const handleOpenClose = (e: any) => {
    if (e.open) {
      // 何かしら必要であれば追加
    } else {
      dismissError();
      window.close(); //暫定対応。エラーによっては閉じたくないパターンが出てきたら呼び出し側からcallback処理を受取できるようにする
    }
  };
  return (
    <Dialog.Root open={errorState} placement={'center'} onOpenChange={handleOpenClose}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content {...dialogContentProps}>
            <Dialog.CloseTrigger {...dialogCloseProps}>
              <CloseButton />
            </Dialog.CloseTrigger>
            <Dialog.Header>
              <Dialog.Title>{LANG.KT_9000_01}</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Text>{errorState?.message}</Text>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild value={'confirm'}>
                <Button color={'#fff'} colorPalette={'blue'} onClick={() => handleOpenClose({ open: false })}>
                  OK
                </Button>
              </Dialog.ActionTrigger>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
export default ErrorDialog;
